import { Dialog } from "primereact/dialog"
import "./ExpireTimeEndTestDialog.scss"

export const ExpireTimeEndTestDialog = ({ expireTestDialog, endTestHandler }: any) => {
  return (
    <>      <Dialog position="top" className="custom-expire-dialog" visible={expireTestDialog}  onHide={() => endTestHandler()} closeOnEscape={false} >
      <div className="Expire-time-box text-center">
        <div className="ex-t-head">Your Time is Up!</div>
        <span className="ex-t-para ">You have reached your time limit for your test!</span>

        <div className="pt-3">
          <button className="ia-btn ia-btn-outline-primary"
            onClick={() => endTestHandler()} >View Result</button>
        </div>
      </div>
    </Dialog>
    </>
  )
}